import React from "react";
import styled from "styled-components";

const Background = styled.div`
    width: 100%;
    background: rgba(0,59,122,1.00);
    min-height: 300px;
    margin-top: 128px;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-content: center;
    align-items: center;
`;

const CopyRight = styled.div`
    order: 0;
    flex: 0 1 auto;
    align-self: auto;
    font-weight: normal;
    font-size: 17px;
    margin-top: 16px;
    color: #fff;
`;

const Footer = () => (
    <Background>
        <CopyRight>&copy; Advanced Spray Decorators 2018 </CopyRight>
    </Background>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.js